import React, { Component } from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link
} from "react-router-dom";

import TokenStats from './TokenStats';

import zuzLogo from '../../assets/images/zuz-logo-filled-text.png';
import zuzLogoFilledNo from '../../assets/images/zuz-logo-filled-no.png';
import netOverlay from '../../assets/images/net-overlay.png';
import pyramid from '../../assets/images/pyramid.png';
import funnel from '../../assets/images/geyser-glow.png';
import Ethereum from '../../assets/images/ethereum.png';
import MetaMask from '../../assets/images/meta-mask.png';
import ChainCircle, { RightArrow, RefreshLogo } from '../Svg/index';

import styles from './stylesheets/GuestUserHeader.module.css';

import VerifiedUserStatus from './VerifiedUserStats.js';
export class GuestUserHeader extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isUserRegistered: false,
        }
    }
    
    render() {
        return (
            <>
            <div className={styles.zuzLogo}>
                <img src={zuzLogo} alt="zuz logo" />
            </div>
            <div className={styles.verifiedUserStatusPre}>
                <VerifiedUserStatus isUserRegistered={this.state.isUserRegistered}></VerifiedUserStatus>
            </div>
            </>
        )
    }
}

export default GuestUserHeader
